module.exports = __webpack_public_path__ + "static/img/matter_lun2.2fe3a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matter/matter_lun2.jpg
// module id = MGg4
// module chunks = 1